import React from 'react';

const CustomDialog = ({ title, message, isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="dialog-overlay">
            <div className="dialog-box">
                <h3 className="dialog-title">{title}</h3>
                <p style={{ fontSize: '0.875rem', color: '#374151', marginBottom: '1.5rem' }}>{message}</p>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
                    {onConfirm && (
                        <button onClick={onClose} className="dialog-button dialog-cancel">
                            취소
                        </button>
                    )}
                    <button
                        onClick={() => {
                            if (onConfirm) {
                                onConfirm();
                                // onConfirm 후 자동으로 닫히게 하려면 onClose도 호출
                                if (onClose) onClose();
                            } else if (onClose) {
                                onClose();
                            }
                        }}
                        className="dialog-button dialog-confirm"
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomDialog;
